import { ChipTabs } from '@shared/components';
import { CalculusTab } from '@retail/calculus/types';
import { Stack } from '@mui/material';

interface Props {
  tabs: {
    label: string | React.ReactNode;
    value: CalculusTab;
  }[];
  currentCalculusArea: CalculusTab;
  setCalculusArea: (option: CalculusTab) => void;
}

export const CalculusTabs = ({ tabs, currentCalculusArea, setCalculusArea }: Props) => {
  return (
    <Stack>
      <ChipTabs
        id="item"
        tabs={tabs}
        currentTab={currentCalculusArea}
        onChange={(_, value) => setCalculusArea(value)}
      />
    </Stack>
  );
};
